import SchemaFormAutoSubmit from "@/components/Schema/SchemaFormAutoSubmit";
import { PageHeader } from "@ant-design/pro-components";
import { createForm } from "@formily/core";
import { Button, Tabs } from "antd";
import { useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MMNavigationRoutes from "../../utils/navigationRoutes";
import { DynamicModuleService } from "@/services/APIs";
import { notify } from "@/components/common/Notification";

const DepartmentFormPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const schemaName = "Add Departments";
  const isEditMode = !!id;

  const formUpload = useMemo(() => createForm({}), []);
  const formUploadRef = useRef<{ handleSave: () => Promise<void> }>(null);

  if (isEditMode) {
    formUpload.setInitialValues({
      id: id,
    });
  }

  const handleSaveDepartment = async () => {
    try {
      await formUpload.validate();
      const formValues = formUpload.values;

      if (isEditMode) {
        // Update existing Department
        await formUploadRef.current?.handleSave();
        // notify.success("Department updated successfully");
        navigate("/mm" + MMNavigationRoutes.DEPARTMENT);
      } else {
        // Create new Department
        const response = await DynamicModuleService.createItem(
          schemaName ?? "",
          formValues
        );

        if (response?.id) {
          navigate("/mm" + MMNavigationRoutes.DEPARTMENT);
          // notify.success("Department created successfully");
        } else {
          notify.error("Failed to get Department ID after creation");
        }
      }
    } catch (error) {
      console.error("Save error:", error);
      // notify.error("Please fill in all required fields correctly");
    }
  };

  const tabStyle = {
    // fontFamily: "Inter, sans-serif",
    // fontSize: "16px",
    // fontWeight: 500,
    // color: "#000000E0",
  };

  return (
    <>
      <PageHeader
        title={isEditMode ? "Edit Department" : "Add Department"}
        onBack={() => navigate("/mm" + MMNavigationRoutes.DEPARTMENT)}
      />

      <Tabs
        items={[
          {
            key: "1",
            label: <span style={tabStyle}>Department</span>,
            children: (
              <>
                <SchemaFormAutoSubmit
                  form={formUpload}
                  schemaName={schemaName ?? ""}
                  recordId={isEditMode ? id : undefined}
                  ref={formUploadRef}
                />
                <div className="flex justify-end gap-4">
                  <Button
                    type="primary"
                    onClick={handleSaveDepartment}
                    style={{ backgroundColor: "#003252" }}
                  >
                    {isEditMode ? "Update" : "Save"}
                  </Button>
                </div>
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default DepartmentFormPage;
